module.exports = {
  "$id": "agentCompany",
  "type": "object",
  "title": "代理人注册",
  "properties": {
    "registerAgentInfo": {
      "title": "代理机构",
      "type": "object",
      "properties": {
        "chiName": {
          "title": "企业名称",
          "type": "string"
        },
        "agentType": {
          "title": "企业类型",
          "type": "string"
        },
        "contactName": {
          "title": "业务员联系人",
          "type": "string"
        },
        "department": {
          "title": "所属营业部",
          "type": "string"
        },
        "officeNo": {
          "title": "OFFICE号",
          "type": "string"
        },
        "phoneNo": {
          "title": "办公电话",
          "type": "string"
        },
        "country": {
          "title": "地区",
          "type": "array"
        }
      },
      "required": [
        "chiName",
        "agentType",
        "contactName",
        "department",
        "officeNo",
        "country"
      ]
    }
  },
  "required": [
    "registerAgentInfo"
  ],
  "errorMessage": {
    "registerAgentInfo.chiName": {
      "required": "请输入企业名称"
    },
    "registerAgentInfo.agentType": {
      "required": "请选择企业类型"
    },
    "registerAgentInfo.contactName": {
      "required": "请输入业务员联系人姓名"
    },
    "registerAgentInfo.department": {
      "required": "请输入所属营业部"
    },
    "registerAgentInfo.officeNo": {
      "required": "请输入航班office号"
    },
    "registerAgentInfo.phoneNo": {
      "required": "请输入有效办公联系电话"
    },
    "registerAgentInfo.country": {
      "required": "请选择地区"
    }
  }
}
